module.exports = __webpack_public_path__ + "0fa013e37f3aacc7af13c35d03af3f5a.pdf";